// PDF Utils für mobile und Desktop-Geräte
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';

export const openPDFOnDevice = async (blob, fileName) => {
    if (Capacitor.isNativePlatform()) {
        // Mobile/Native App - verwende Capacitor Filesystem + File Opener
        try {
            // Blob zu base64 konvertieren
            const base64Data = await blobToBase64(blob);
            
            // Datei im temporären Verzeichnis speichern
            const savedFile = await Filesystem.writeFile({
                path: fileName,
                data: base64Data,
                directory: Directory.Cache
            });

            // PDF mit nativer App öffnen
            await FileOpener.open({
                filePath: savedFile.uri,
                contentType: 'application/pdf',
                openWithDefault: true
            });
        } catch (error) {
            console.error('Error handling PDF on mobile:', error);
            // Fallback: direkter Download
            downloadPDFDirect(blob, fileName);
        }
    } else {
        // Web Browser - normaler Download
        downloadPDFDirect(blob, fileName);
    }
};

// Hilfsfunktion: Blob zu Base64 konvertieren
const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function() {
            const base64Data = reader.result.split(',')[1]; // Entferne data:application/pdf;base64,
            resolve(base64Data);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

// Hilfsfunktion für direkten Download (Web Browser oder Fallback)
const downloadPDFDirect = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
};
